import { t as tr } from './i18n';
/**
 * Datele firmei, trecute chiar de furnizor după ce își trimite oferta prin link
 * (Echipă, Companie): CUI-ul (numele și sediul vin de la ANAF), județele în care
 * livrează și telefonul. Intră direct pe furnizorul din agenda cumpărătorului.
 *
 * E proba pentru înscrierea furnizorilor: dacă destui completează, urmează
 * formularul separat și rețeaua de furnizori (jurnalul, 10 octombrie).
 */

/** Județele României, plus București, în ordine alfabetică. */
export const RO_COUNTIES = [
  'Alba',
  'Arad',
  'Argeș',
  'Bacău',
  'Bihor',
  'Bistrița-Năsăud',
  'Botoșani',
  'Brăila',
  'Brașov',
  'București',
  'Buzău',
  'Călărași',
  'Caraș-Severin',
  'Cluj',
  'Constanța',
  'Covasna',
  'Dâmbovița',
  'Dolj',
  'Galați',
  'Giurgiu',
  'Gorj',
  'Harghita',
  'Hunedoara',
  'Ialomița',
  'Iași',
  'Ilfov',
  'Maramureș',
  'Mehedinți',
  'Mureș',
  'Neamț',
  'Olt',
  'Prahova',
  'Sălaj',
  'Satu Mare',
  'Sibiu',
  'Suceava',
  'Teleorman',
  'Timiș',
  'Tulcea',
  'Vâlcea',
  'Vaslui',
  'Vrancea',
] as const;

/** Livrează oriunde; ține locul listei întregi. */
export const ALL_COUNTRY = 'Toată țara';

export const isCounty = (c: string): boolean =>
  c === ALL_COUNTRY || (RO_COUNTIES as readonly string[]).includes(c);

/** „Brașov, Covasna, Sibiu” sau „toată țara”; '' = nu s-a spus. */
export function countiesText(counties: string[]): string {
  if (counties.includes(ALL_COUNTRY)) return tr('toată țara');
  return counties.join(', ');
}

/** Ce vede furnizorul pe pagina lui despre datele firmei. */
export interface PublicSupplierProfile {
  cui: string;
  /** de la ANAF; '' = încă neverificat */
  name: string;
  address: string;
  counties: string[];
  phone: string;
  /** ISO 8601: când le-a trecut furnizorul; null = încă nu */
  filledAt: string | null;
}

export interface SupplierProfileInput {
  cui: string;
  counties: string[];
  phone: string;
}
